module.exports = __webpack_public_path__ + "img/2024-08_faculty-achievements.9e905df4.jpg";